import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Alert
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import "../../../style/subAdmin/UserDetails.scss";
import { get_user_details } from "../../../redux/actions/subAdminActions";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import isEmpty from "lodash.isempty";
import { Notification } from "../../../components/notifications";
import loader from "../../../style/loader/loader.scss";
import "../../../style/detailPage.scss";

const history = createBrowserHistory();
let isLoading = "false";
class UserDetails extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    const viewLink = (props.match && props.match.params) && `userDetails/${props.match.params.userId}`
    super(props);
    this.state = {
      userDetails: {},
      path: ["Home", "Manage Sub-Admins", "View Details"],
      links:["home", "userList", viewLink],
    };
  }

  componentWillMount() {
    let userIdParams = this.props.match.params.userId
      ? this.props.match.params.userId
      : "";
    if (userIdParams !== "") {
      isLoading = "true";
      this.props.get_user_details(userIdParams);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.userDetails !== nextProps.userDetails &&
      !isEmpty(nextProps.userDetails)
    ) {
      if (nextProps.userDetails.data) {
        isLoading = "false";
      }
      this.setState({ userDetails: nextProps.userDetails.data });
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
      }
    }
  }

  render() {
    let userData =
      this.state.userDetails && this.state.userDetails
        ? this.state.userDetails
        : {};

    return (
      <div>
        <div className="col-lg-12 detail-Page">
          {isLoading == "true" ? (
            <div className="loader">
              <p className="loading-message">
                <i>Loading...</i>
              </p>
              <div className="spinner">
                <div className="dot1" />
                <div className="dot2" />
              </div>
            </div>
          ) : (
            ""
          )}
          <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          <div className="panel">
            <header className="panel-heading">Employee Details</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicUserNameText">
                    <ControlLabel> User Name : </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicEmailText">
                    <ControlLabel>Email :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicFirstNameText">
                    <ControlLabel>First Name :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> Last Name :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel>Date Of Birth :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel>Gender :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicPhoneText">
                    <ControlLabel>Phone :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicAddressOneText">
                    <ControlLabel> Address1 :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>Address2 :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>Country :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>State :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel>City :</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicZipText">
                    <ControlLabel>Zipcode :</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsStatusSelect">
                    <ControlLabel>Status :</ControlLabel>
                  </FormGroup>
                </Col>

                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicUserNameText">
                    <ControlLabel> {userData.userName}</ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicEmailText">
                    <ControlLabel>{userData.email}</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicFirstNameText">
                    <ControlLabel>{userData.firstName}</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicLastNameText">
                    <ControlLabel> {userData.lastName}</ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicDOBText">
                    <ControlLabel className="values-name">
                      {userData.dob}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsSelect">
                    <ControlLabel className="values-name">
                      {userData.gender}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicPhoneText">
                    <ControlLabel className="values-name">
                      {" "}
                      {userData.phone}{" "}
                    </ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formBasicAddressOneText">
                    <ControlLabel className="values-name">
                      {userData.address1}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {userData.address2}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {userData.country}{" "}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {userData.state}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicAddressTwoText">
                    <ControlLabel className="values-name">
                      {userData.city}
                    </ControlLabel>
                  </FormGroup>

                  <FormGroup controlId="formBasicZipText">
                    <ControlLabel className="values-name">
                      {userData.zipcode}
                    </ControlLabel>
                  </FormGroup>
                  <FormGroup controlId="formControlsStatusSelect">
                    <ControlLabel className="values-name">
                      {userData.status}
                    </ControlLabel>
                  </FormGroup>
                </Col>
              </Row>

              <Row className="BtnRow">
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    onClick={() => this.context.router.history.push(`/userList`)}
                  >
                    Back
                  </Button>
                </Col>
              </Row>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: state.subAdminReducer.userDetails,
  error: state.subAdminReducer.error
});
export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, { get_user_details })
)(UserDetails);



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/UserDetails.js